import * as moment from 'moment';
import { DateConverter, NativeDateConverter } from 'src/app/core/services/mapper/converters';
import { Produit } from '../../habilitation/models/produit.model';
import { RefMouvement } from './ref-mouvement.model';
import { Operateur } from '../../intervenant/models/operateur.model';

export class HistoriqueMouvement {
    static jsonMap = {
        idMouvement: { key: 'idMouvement' },
        idOperateur: { key: 'idIntervenant' },
        code: { key: 'codeMouvement', optional: true, default: '' },
        idRefMouvement: { key: 'idRefMouvement', optional: true },
        idOrganisme: { key: 'idOrganisme', optional: true },
        dateMouvement: { key: 'dateMouvement', converter: new DateConverter(), optional: true },
        dateDebut: { key: 'dateDebut', converter: new NativeDateConverter(), optional: true },
        logement: { key: 'logement', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        libelleCahier: { key: 'libelleCahier', optional: true, default: '' },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        annee: { key: 'annee', optional: true },
        estControle: { key: 'estControle', optional: true },
        volume: { key: 'volume' },
        estOrigine: { key: 'estOrigine' },
        estLu: { key: 'estLu' },
        nonControlable: { key: 'nonControlable' },
        numeroDeclaration: { key: 'numeroDeclaration', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true },
        numeroCVI: { key: 'numeroCVI', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' }
    };

    idMouvement: number;
    idOperateur: number;
    code: string;
    idRefMouvement: number;
    idOrganisme: number;
    dateMouvement: moment.Moment;
    dateDebut: Date;
    logement: string;
    numeroLot: string;
    libelleCahier: string;
    codeProduit: string;
    annee: number;
    estControle: boolean;
    volume: number;
    estOrigine: boolean;
    estLu: boolean;
    nonControlable: boolean;
    numeroDeclaration: string;
    numeroDossier: number;
    numeroCVI: string;
    raisonSociale: string;

    cvi = 0;
    operateur: Operateur = new Operateur();
    produit: Produit = new Produit();
    refMouvement: RefMouvement = new RefMouvement();
}
